import LoginComponent from '@/views/Login.vue';
import RouteNames from '../constants/route-names';

const loginRoute = {
  component: LoginComponent,
  name: RouteNames.Login,
  path: '/',
  props: route => ({
    passwordReset: route.query.passwordReset,
    reDir: route.query.reDir || route.query.redir,
    reDirRouteName: route.query.reDirRouteName,
    existingQueryParams: route.query.existingQueryParams,
  }),
};

export default loginRoute;
